import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/gatsby-theme-axii/src/templates/page/index.tsx";
import { GatsbySeo } from "gatsby-plugin-next-seo";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <GatsbySeo title="Homepage" mdxType="GatsbySeo" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/37a46e551f5722397da2191e728b8dda/8537d/logo.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADHklEQVQozw2R71MTdBzH9wf047pO7QYDFbRMxFOpsxK7nED2IHfA2I8GCOyHg3Yr5RiMIcEa2wKTKYLAoE1w6IjBbmzBmjDZZYfCQYLXpXmd9kyf9B+8+j74PH3d6/15SY4YDJTabZTZm1G4ujEGQthjKRyxJZwLaS7F72KLxuiIR+hbSXDttyS9mUWiD5b578kqr7ZT/JsJ8iI9wtPFy0h2l5aRL/+M/adOcqBEznGVllP1BsoMZlQX2viy0Yqyw4Fjfgp3KowvE2H4XoSnD+O8XIvyPD3Oi6Vhni8N8de8C4lUfprXdu1EevgQ+04Wc0Aup+iskg/LdRRrqympqae6x0Pb7G3sET/e1ATLK7d4eT/Es+QQj8MOtqZa2A7b2QxdQJKr0bLr6DFyPigS0+2oLvs46+yjfugOimYbNW4Xl2JzdMXCeBYn+SF1k7WVAK8y4wLWwdq4hfWAhdUxM2vBRiQ7yyvJVZTzpkxGYYWKUls7n7c6+FRvRHbwPQG8SPv0EM54COtgF20BL9OjnaRGHaSvm0n2m0j6jCwPNPCrr1oAFQqylGqyTxTzdl4+x3TVfNRgQHqwgC/OnxNmAWyhfr4JCOsuC5YrrYz3NRH2mpnprmLKqWeu18jKYAP3R/VIZFUVSCuU5FWpeUsAc45/zB4BlxUWYB0bxJOIYg/5aRrspvWmE9fsVRbCnWxMtpL8sZaEV8u9gTpW/Q088J9DkqOqYK9GTa6om11yhtezsnlDmkVRZTl1V3roic3QtxDBMz+GOzaA+5cbzM+6+POOnczI1yxfq+OhgD2aMLIZqBdArYq9X2nYo1aRp9Gx4/AR3jlUyAmjHo3LgTM6zfexSXzpCRFF/DLh4/d4N//MtbN9u5mtiSZxJv4I6lkf04nKOi27tWphWSWgGvJFpILKSk5bm9B5O7kYvCqiXMedGMEx10t/ys92/DueRWw8nvpWmJnFmdj4SZiOqpDs0+t5/7yZ/TU63q2tpVBv4pNGE2darKiEYeOwS0Rx45jpx3M3SCjt5++ojSc/t7B1y8KjSTMbYupmoJZ1v5L/AbhaHsby3u8AAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/37a46e551f5722397da2191e728b8dda/2b86f/logo.webp 240w", "/static/37a46e551f5722397da2191e728b8dda/cdb16/logo.webp 480w", "/static/37a46e551f5722397da2191e728b8dda/6c7d1/logo.webp 960w", "/static/37a46e551f5722397da2191e728b8dda/68fc1/logo.webp 1200w"],
              "sizes": "(max-width: 960px) 100vw, 960px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/37a46e551f5722397da2191e728b8dda/58794/logo.png 240w", "/static/37a46e551f5722397da2191e728b8dda/3166f/logo.png 480w", "/static/37a46e551f5722397da2191e728b8dda/fde0f/logo.png 960w", "/static/37a46e551f5722397da2191e728b8dda/8537d/logo.png 1200w"],
              "sizes": "(max-width: 960px) 100vw, 960px",
              "type": "image/png"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/37a46e551f5722397da2191e728b8dda/fde0f/logo.png",
              "alt": "AXII logo",
              "title": "AXII logo",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h1>{`AXII - A Gatsby blog theme.`}</h1>
    <hr></hr>
    <p>{`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut imperdiet venenatis risus ac malesuada. Sed accumsan tellus libero, porttitor aliquam neque consequat aliquet. Nulla massa libero, ultricies ut sapien ac, sollicitudin pretium felis. Quisque non tellus fringilla, tempus sapien nec, vulputate nulla. Vivamus eleifend fringilla felis, ac facilisis nunc congue in. Nullam ac aliquam neque. Nam egestas molestie venenatis. Vivamus vitae ipsum in sem dapibus sodales vitae nec arcu.`}</p>
    <p>{`Aliquam sed malesuada purus, vel mattis libero.`}</p>
    <p><a parentName="p" {...{
        "href": "https://eshlox.net",
        "target": "_blank",
        "rel": "noreferrer"
      }}>{`eshlox.net`}</a></p>
    <h4>{`Etiam lobortis elementum dui eleifend convallis`}</h4>
    <p>{`Proin fermentum massa vel dignissim molestie. Fusce sollicitudin viverra aliquam. Nulla porttitor nec odio vel sollicitudin. Proin quam urna, pharetra quis facilisis quis, laoreet eu dolor. Donec luctus, neque porta gravida imperdiet, ipsum nisi tincidunt tortor, vel ullamcorper neque leo id nulla. Proin nec mauris eu lectus tempor faucibus ut in dolor. Etiam lobortis elementum dui eleifend convallis. Praesent nulla elit, blandit ac odio non, pulvinar ultricies nisi.`}</p>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Phasellus varius felis dictum, cursus nisi ac, tristique enim. Vestibulum fringilla non leo nec rutrum. Vestibulum nec venenatis lacus, nec efficitur eros. Maecenas porttitor varius odio sed volutpat.`}</p>
    </blockquote>
    <hr></hr>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/2c642/amanda-kerr-jpMyAqHat7g-unsplash.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "150%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAwQC/8QAFgEBAQEAAAAAAAAAAAAAAAAAAgED/9oADAMBAAIQAxAAAAHE0xDLgpBVAunNdlQp/8QAGxAAAgMBAQEAAAAAAAAAAAAAAAIBAxESEyH/2gAIAQEAAQUCisREzIJvlk9+ZW6uVVoH5z4adGn/xAAWEQEBAQAAAAAAAAAAAAAAAAABESD/2gAIAQMBAT8BCY//xAAXEQEBAQEAAAAAAAAAAAAAAAABEAIR/9oACAECAQE/AXYzk//EAB0QAAECBwAAAAAAAAAAAAAAAAAQMQEgISIyUWH/2gAIAQEABj8CYhRNdGM0tl//xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhEDGB/9oACAEBAAE/IW9qkJTrhSaG5CMnR4wk0Is2vs0lItoMluP/2gAMAwEAAgADAAAAENv0j//EABYRAQEBAAAAAAAAAAAAAAAAABABEf/aAAgBAwEBPxCo0//EABcRAQEBAQAAAAAAAAAAAAAAAAARITH/2gAIAQIBAT8Q5Krta//EACAQAQADAAIABwAAAAAAAAAAAAEAESExQRBRYXGBsdH/2gAIAQEAAT8QbxJptyZ9BtvmDcBXtCV7CpyfsqyMLOo91po5srgVqtL+JgqXaX6udxXongCuKy/mz//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/2b86f/amanda-kerr-jpMyAqHat7g-unsplash.webp 240w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/cdb16/amanda-kerr-jpMyAqHat7g-unsplash.webp 480w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/6c7d1/amanda-kerr-jpMyAqHat7g-unsplash.webp 960w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/ff8d7/amanda-kerr-jpMyAqHat7g-unsplash.webp 1440w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/f3ff0/amanda-kerr-jpMyAqHat7g-unsplash.webp 1920w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/e352a/amanda-kerr-jpMyAqHat7g-unsplash.webp 3744w"],
              "sizes": "(max-width: 960px) 100vw, 960px",
              "type": "image/webp"
            }}></source>{`
        `}<source parentName="picture" {...{
              "srcSet": ["/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/f06cd/amanda-kerr-jpMyAqHat7g-unsplash.jpg 240w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/a5e48/amanda-kerr-jpMyAqHat7g-unsplash.jpg 480w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/1fe05/amanda-kerr-jpMyAqHat7g-unsplash.jpg 960w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/06430/amanda-kerr-jpMyAqHat7g-unsplash.jpg 1440w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/af8d6/amanda-kerr-jpMyAqHat7g-unsplash.jpg 1920w", "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/2c642/amanda-kerr-jpMyAqHat7g-unsplash.jpg 3744w"],
              "sizes": "(max-width: 960px) 100vw, 960px",
              "type": "image/jpeg"
            }}></source>{`
        `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/7a0e76dd95f420c9e8cf2ecfdcf7d3c0/1fe05/amanda-kerr-jpMyAqHat7g-unsplash.jpg",
              "alt": "Photo by Amanda Kerr on Unsplash",
              "title": "Photo by Amanda Kerr on Unsplash",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      